import WorkflowTab from './subpages/workflow-tab/route'
import PriceTab from './subpages/price-tab/route'
import UsageTab from './subpages/usage-tab/route'
import ContentTab from './subpages/content-tab/route'
import LicenseTab from './subpages/license-tab/route'
import NotesTasksTab from './subpages/notes-tasks-tab/route'
import EvaluationsTab from './subpages/evaluations-tab/route'
import OrdersInvoicesTab from './subpages/orders-invoices-tab/route'
import TitleListTab from './subpages/title-list-tab/route'
import ImplementationsTab from './subpages/implementations-tab/route'
import EmailsHistoryTab from './subpages/emails-history-tab/route'

export default {
  path: '/subscriptions/:id',
  component: () => import(/* webpackChunkName: "subscription-show" */ './SubscriptionsShow'),
  props: true,
  meta: {
    requiresAuth: true
  },
  redirect: '/subscriptions/:id/workflow',
  children: [
    WorkflowTab,
    PriceTab,
    UsageTab,
    ContentTab,
    LicenseTab,
    NotesTasksTab,
    EvaluationsTab,
    OrdersInvoicesTab,
    TitleListTab,
    ImplementationsTab,
    EmailsHistoryTab
  ]
}
